


export class DivisionMileStones {
       constructor(counts: string, data: DivisionMileStone[]) {
              this.counts = counts;
              this.data = data;
       }
       counts: string;
       data: DivisionMileStone[];
}


export class DivisionMileStone {
       constructor(
              id: string,
              automated: boolean,
              isDefault: boolean | null,
              divisionCode: string,
              mileStoneCode: string,
              mileStoneName: string,
              mileStoneOrder: number,
              mode: string,
              taskCode: string,
              taskName: string,
              taskOrder: number,
              status: boolean,
              createdOnDate: Date,
              createdBy: string,
              updatedOnDate?: Date | null,
              updatedBy?: string | null
       ) {
              this.id = id;
              this.automated = automated;
              this.isDefault = isDefault;
              this.divisionCode = divisionCode;
              this.mileStoneCode = mileStoneCode;
              this.mileStoneName = mileStoneName;
              this.mileStoneOrder = mileStoneOrder;
              this.mode = mode;
              this.taskCode = taskCode;
              this.taskName = taskName;
              this.taskOrder = taskOrder;
              this.status = status;
              this.createdOnDate = createdOnDate;
              this.createdBy = createdBy;
              this.updatedOnDate = updatedOnDate || null;
              this.updatedBy = updatedBy || null;
       }

       public id: string;
       public automated: boolean;
       public isDefault: boolean | null;
       public divisionCode: string;
       public mileStoneCode: string;
       public mileStoneName: string;
       public mileStoneOrder: number;
       public mode: string;
       public taskCode: string;
       public taskName: string;
       public taskOrder: number;
       public status: boolean;
       public createdOnDate: Date;
       public createdBy: string;
       public updatedOnDate?: Date | null;
       public updatedBy?: string | null;

}



export interface MileStonesRequest {
       milestones: {
              id?: string | null;
              automated: boolean;
              isDefault: boolean | null;
              divisionCode: string;
              mileStoneCode: string;
              mileStoneName: string;
              mileStoneOrder: number;
              taskCode: string;
              taskName: string;
              taskOrder: number;
              status: boolean;
              createdBy?: string | null;
              updatedBy?: string | null;
       }[];
       mode: 'draft' | 'released';
       workFlowId: string;
}